import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { useFormHook } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import {
  getDefaultValueByQuestionId,
  saveEddQuestionToLocalStore,
} from '@Pages/happyFlowPages/eddQuestions/shared.utils';
import { EDD_VERSION } from '@Pages/happyFlowPages/eddQuestions/consts';
import { useBoundStore } from '@Store/useBoundStore';
import { useNavigationManager } from '@Router/useNavigationManager';
import { usePostEddData } from '@Pages/happyFlowPages/eddQuestions/hooks/usePostEddData';
import { RoutesMap } from '@Router/router.types.ts';

export const useNonprofitDescriptionCLogic = () => {
  const { mutateAsync: postEddData, isPending: isPostingEddData } = usePostEddData();
  const { getEddEmbeddedQuestions } = useBoundStore((state) => state);
  const { navigateToNextPage } = useNavigationManager();
  const { t } = useTranslation('eddQuestions');
  const { t: tValidation } = useTranslation('enJSON');

  const formMethods = useFormHook({
    schemaTitle: 'Nonprofit Description C',
    formDefaultValues: {
      [EddEmbeddedFields.EDD_NONPROFIT_DESCRIPTION_C]:
        getDefaultValueByQuestionId(EddEmbeddedFields.EDD_NONPROFIT_DESCRIPTION_C) || '',
    },
    formSchema: z.object({
      [EddEmbeddedFields.EDD_NONPROFIT_DESCRIPTION_C]: z
        .string()
        .min(1, { message: tValidation('validation.required') })
        .min(30, { message: tValidation('validation.min30chars') })
        .max(300, { message: tValidation('validation.max300chars') }),
    }),
  });

  const handleSubmit = async () => {
    saveEddQuestionToLocalStore({
      question: t('organic.nonprofitDescriptionC.question'),
      questionId: EddEmbeddedFields.EDD_NONPROFIT_DESCRIPTION_C,
      answer: JSON.stringify(formMethods.getValues(EddEmbeddedFields.EDD_NONPROFIT_DESCRIPTION_C)),
    });

    try {
      await postEddData({
        version: EDD_VERSION,
        results: getEddEmbeddedQuestions(),
      });
      navigateToNextPage(RoutesMap.EDD_NONPROFIT_DESCRIPTION_C);
    } catch (error) {
      console.error(error);
    }
  };

  return {
    formMethods,
    handleSubmit,
    isLoading: isPostingEddData,
  };
};
